import {Card, Space} from "antd";
import {useGetProfileContext} from "../../../context/profile/profile-context";
import {EmailUpdateForm} from "../email-update-form";
import {PasswordUpdateForm} from "../password-update-form";
import {TwoFactorSection} from "../two-factor/TwoFactorSection";
import {IS_TWO_FACTOR_FEATURE_ENABLED} from "../../../services/config";

export function AccountSettings() {
  const {state: profileState} = useGetProfileContext();
  const isSocialAuthCoach = profileState.profileData.isSocialAuth;

  return (
    <div style={{marginTop: 0, marginBottom: "3rem"}}>
      <Space direction="vertical" size={24} style={{display: "flex"}}>
        {IS_TWO_FACTOR_FEATURE_ENABLED && (
          <Card style={{borderRadius: "5px", border: "1px solid #F0F0F0"}}>
            <TwoFactorSection />
          </Card>
        )}
        <Card style={{borderRadius: "5px", border: "1px solid #F0F0F0"}}>
          <EmailUpdateForm email={profileState.profileData.email.toLowerCase()} />
        </Card>
        {!isSocialAuthCoach && (
          <Card style={{borderRadius: "5px", border: "1px solid #F0F0F0"}}>
            <PasswordUpdateForm />
          </Card>
        )}
      </Space>
    </div>
  );
}
